import cn from "classnames";
import { EquipmentModel } from "entities/RailSearchCard";
import { resolveDateValues } from "entities/shared/utils";
import { useTranslation } from "shared/localization/localization";
import { LineRow } from "./LineRow";
import styles from "./LineList.module.scss";

type LineProps = {
  className?: string;
  data: EquipmentModel;
};

export const Line: RFC<LineProps> = ({ data, className }) => {
  const { t } = useTranslation();
  const { departureDate, arrivalDate } = resolveDateValues({
    atd: data.atd,
    etd: data.etd,
    ata: data.ata,
    eta: data.eta,
    formatedDate: true,
    useValuePlaceholder: true,
    dateFormatOptions: { withTime: true },
  });

  return (
    <div className={cn(styles.line, className)}>
      {data.number && <LineRow title={t("Name")} value={data.number} />}
      {data.from?.formattedName && <LineRow title={t("Country")} value={data.from?.formattedName} />}
      {data.trainNumber && <LineRow title={t("Train")} value={data.trainNumber} />}
      {data.wagonNumber && <LineRow title={t("Wagon")} value={data.wagonNumber} />}
      <LineRow title={departureDate.unit} value={departureDate.value} />
      <LineRow title={arrivalDate.unit} value={arrivalDate.value} />
    </div>
  );
};
